//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { formatConfiguredTime, formatTrueFalse } from '../../components/helpers.js'
import Table from '../../components/Table/Table.vue'
import ReportRemarkImportantCheckbox from './ReportRemarkImportantCheckbox.vue'

export default {
  name: 'ReportReworksRemarks',
  components: {
    Table,
    ReportRemarkImportantCheckbox
  },
  props: {
    report: {
      type: Object,
      default () {
        return {}
      }
    },
    remarks: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data: function () {
    return {
      remarksSections: null,
      columns: [
        {
          name: 'name',
          label: 'Секция/операция/материал',
          field: 'name',
          align: 'left',
          style: 'width: 20%;',
          headerStyle: 'width: 20%;'
        },
        {
          name: 'comment',
          label: 'Текст замечания',
          field: 'comment',
          align: 'left'
        },
        {
          name: 'userFio',
          label: 'Автор',
          field: 'userFio',
          align: 'left'
        },
        {
          name: 'time',
          label: 'Дата/время',
          field: 'time',
          format: (val) => formatConfiguredTime(val),
          align: 'left'
        },
        {
          name: 'changed',
          label: 'Изменён',
          field: 'changed',
          format: formatTrueFalse,
          align: 'left'
        }
      ]
    }
  },
  watch: {
    remarks: {
      handler: function (newRemarks) {
        if (newRemarks.length === 0) {
          this.remarksSections = null
          return
        }
        this.remarksSections = new Set(newRemarks.map(remark => remark.section))
      },
      immediate: true
    }
  },
  methods: {
    getRemarksOfSection: function (section) {
      return this.remarks.filter(remark => remark.section === section)
    }
  }
}

